import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

// Todo esto practicamente sirve para manejar el numDocumento del usuario autenticado
// Estado global de autenticación
// user: { numDocumento: string } | null
// login(numDocumento: string), logout()
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
	const [user, setUser] = useState(() => {
		try {
			const raw = localStorage.getItem('auth:user');
			return raw ? JSON.parse(raw) : null;
		} catch {
			return null;
		}
	});

	useEffect(() => {
		try {
			if (user) localStorage.setItem('auth:user', JSON.stringify(user));
			else localStorage.removeItem('auth:user');
		} catch {
			// ignore
		}
	}, [user]);

	const value = useMemo(() => ({
		user,
		login: (numDocumento) => setUser({ numDocumento }),
		logout: () => setUser(null),
	}), [user]);

	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
}

export function useAuth() {
	const ctx = useContext(AuthContext);
	if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
	return ctx;
}

export function useNumDocumento() {
	const { user } = useAuth();
	return user?.numDocumento ?? null;
}

